import React, { useState } from 'react'
import CustomTable from '../../../CustomTable'
import { CardListStyle, CardStyle, EditStyle } from '../style'
import { Typography, Statistic } from 'antd'
import { EditOutlined, CheckOutlined } from '@ant-design/icons'
import useAxios from 'axios-hooks';
import currency from 'currency.js';

const OtherDetailTable = ({ invoice_group_id, resign }) => {

  const { Paragraph } = Typography
  const [currentPage, setCurrentPage] = useState(1)
  const [search, setSearch] = useState('')
  const [sort, setSort] = useState('')
  const [pageSize, setPageSize] = useState(20)
  const [id, setId] = useState()
  const [{ data, loading, error }, refetch] = useAxios(
    {
      url: `/admins/api/invoice_groups/${invoice_group_id}/other_details?per_page=${pageSize}&page=${currentPage}&search=${search}&resign=${resign}&sort=${sort ?? ''}`,
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
    },
    {
      useCache: false,
    }
  )

  const [, adjust] = useAxios(
    {
      url: `/admins/api/invoice_groups/${invoice_group_id}/other_details/${id}`,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
    }, {
      manual: true
    }
  )

  const columns = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => <a>{index + 1}</a>,
    },
    {
      title: 'เลขบัตรประชาชน',
      dataIndex: 'citizen_id',
      key: 'citizen_id',
      sorter: true,
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'เลขที่สัญญา',
      key: 'loanId',
      sorter: true,
      render: (text, _) => <a>{_.raw_data.loanId}</a>,
    },
    {
      title: 'ชื่อ',
      dataIndex: 'firstname',
      key: 'firstname',
      sorter: true,
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'นามสกุล',
      dataIndex: 'lastname',
      key: 'lastname',
      sorter: true,
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'สินเชื่อ',
      key: 'productName',
      sorter: true,
      render: (text, _) => <a>{_.raw_data.productName}</a>,
    },
    {
      title: 'ยอดหนี้รวม',
      key: 'osb',
      sorter: true,
      render: (text, _) => <a>{currency(_.raw_data.osb).format({ symbol: '', separator: ',', precision: 2 })}</a>,
    },
    {
      title: 'ยอดชำระขั้นต่ำ',
      key: 'minDue',
      sorter: true,
      render: (text, _) => <a>{currency(_.raw_data.minDue).format({
        symbol: '',
        separator: ',',
        precision: 2
      })}</a>,
    },
    {
      title: 'โอนให้สถาบันการเงิน',
      dataIndex: 'actual_lender',
      key: 'actual_lender',
      sorter: true,
      width: 300,
      render: (actual, _) => <EditStyle>
        <Paragraph
          editable={{
            icon: <EditOutlined />,
            enterIcon: <CheckOutlined />,
            tooltip: 'Click To Edit Widget Name',
            onChange: async (val) => {
              await adjust({
                data: JSON.stringify({
                  actual_lender: currency(val).format({ symbol: '', separator: '', precision: 4 })
                })
              })
              await refetch()
            },
            onStart: async (val) => {
              setId(_.id)
            },
            onEnd: async () => {
              await refetch()
            }
          }}
        >
          {currency(actual).format({ symbol: '', separator: ',', precision: 2 })}
        </Paragraph></EditStyle>,
    },
  ]

  return <>
    <CardListStyle>
      <CardStyle>
        <Statistic title="รวมยอดหนี้รวม" value={data ? data.total_osb : 0} precision={2} />
      </CardStyle>
      <CardStyle>
        <Statistic title="รวมยอดชำระขั้นต่ำ" value={data ? data.total_min_due : 0} precision={2} />
      </CardStyle>
      <CardStyle>
        <Statistic title="รวมโอนให้สถาบันการเงิน" value={data ? data.total_actual_lender : 0} precision={2} />
      </CardStyle>
    </CardListStyle>
    <CustomTable
      pageSize={pageSize}
      setPageSize={setPageSize}
      searchPlaceholder={'ค้นหาโดย ชื่อ นามสกุล เลขบัตรประชาชน เลขที่สัญญา'} loading={loading} columns={columns}
      data={data ? data.invoice_other_details.map(obj => ({ ...obj, key: obj.id })) : []} total={data ? data.total_pages : 0} currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearch={setSearch}
      setSort={setSort}
    />
  </>
}

export default OtherDetailTable
